<template>
    <div class="scrollarea">
        <div class="scrollarea__wrapper">
            <div class="scrollarea__container">
                <div v-if="$slots.header" class="scrollarea__header">
                    <slot name="header"></slot>
                </div>

                <div ref="body" class="scrollarea__body" :class="{ 'scrollarea__scroll': scroll.visible, 'scrollarea__gradient-bottom': scroll.reached.bottom }" @scroll="onScroll">
                    <slot name="body"></slot>
                </div>

                <div v-if="$slots.footer" class="scrollarea__footer">
                    <slot name="footer"></slot>
                </div>

            </div>
        </div>
    </div>

</template>

<script lang="ts">
    import Vue from 'vue'

    interface ScrollState {
        visible: boolean
        reached: {
            top: boolean
            bottom: boolean
        }
    }

    export default Vue.extend({
        
        name: 'SCROLLAREA',

        data(): { scroll: ScrollState } {
            return {
            scroll: {
                visible: false,
                reached: {
                top: false,
                bottom: false,
                },
            },
            }
        },

        mounted(): void {
            this.setupScroll(this.$refs.body as HTMLElement)
        },

        updated(): void {
            this.setupScroll(this.$refs.body as HTMLElement)
        },

        methods: {
            onScroll(e: Event): void {
            const target = e.target as HTMLElement
            this.setupScroll(target)
            },

            setupScroll(element: HTMLElement): void {
            if (!element) return
            
            this.scroll.visible = element.scrollHeight > element.offsetHeight
            this.scroll.reached.bottom = !(element.scrollTop >= (element.scrollHeight - element.offsetHeight))
            },
        },
    })
</script>

<style lang="stylus" scoped>

    ::-webkit-scrollbar
      width: 2px;


    ::-webkit-scrollbar-track
      /* -webkit-box-shadow: inset 0 0 2px #1E4972; */
      /* -webkit-box-shadow: inset 0 0 2px #c2c2c2; */
      /* -webkit-box-shadow: inset 0 0 2px #F7941D; */
      -webkit-box-shadow: inset 0 0 2px rgba(0,0,0,0.3);
      border-radius: 2px;

    ::-webkit-scrollbar-thumb
      border-radius: 10px;
      /* -webkit-box-shadow: inset 0 0 2px '#1E4972'; */
      /* -webkit-box-shadow: inset 0 0 2px #c2c2c2; */
      /* -webkit-box-shadow: inset 0 0 2px #F7941D; */
      -webkit-box-shadow: inset 0 0 2px rgba(0,0,0,0.8);


    .scrollarea

        position: relative

        width: 100%
        height: 100%


        &__wrapper

            position: absolute

            bottom: 0
            left: 0
            right: 0
            top: 0

        &__container

            display: flex
            flex-direction: column

            width: 100%
            height: 100%

        &__header

            display: flex
            flex-wrap: wrap
            flex: 0 0 auto

            /* padding: 16px */

        &__body

            /* flex: 1 1 auto */
            flex: auto
            overflow-y: auto
            overflow-x: hidden
            min-height: 0px

            position: relative

        &__footer

            display: flex
            flex-wrap: wrap
            flex: 0 0 auto

            /* min-height: 30% */
            /* max-height: 30% */
            /* display: auto */
            /* overflow-y: auto */
            /* align-items: center */
            /* flex: 0 0 auto */

            /* padding: 16px */

        /* &__footer
            min-height: 40%
            display: flex
            align-items: center
            flex: 0 0 auto */

            /* padding: 16px */

</style>
